import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useLoading } from "../../../components/Loading/useLoading";
import { useEffect, useState } from "react";
import { CopiarReporte, EditarReporte, GetEntity, GetReporte } from "../../../hooks/reporteQuery";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";
import { Autocomplete, Box, Button, FormControl, FormHelperText, Grid, IconButton, MenuItem, Select, Tab, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import { Cancel, Delete, Search } from "@mui/icons-material";
import { SideList } from "./components/sideList";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { UserActions } from "./components/userActions";


export const EditarQuery = () => {

	const { id } = useParams();
  const username = useSelector((state) => state.auth.user.username);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const {setAppLoading} = useLoading();
	const { enqueueSnackbar } = useSnackbar();
	const { getEntityMutation } = GetEntity();
	const { getReporteMutation } = GetReporte();
	const { editarReporteMutation } = EditarReporte();
	const { copiarReporteMutation } = CopiarReporte();
	const [reportName, setReportName] = useState(null);
	const [reportDesc, setReportDesc] = useState(null);
	const [originalList, setOriginalList] = useState([]);
	const [leftList, setLeftList] = useState([]);
	const [rightList, setRightList] = useState([]);
	const [selectedToLeft, setSelectedToLeft] = useState([]);
	const [selectedToRight, setSelectedToRight] = useState([]);
	const [filtro, setFiltro] = useState("");
	const [listaFiltrada, setListaFiltrada] = useState([]);
	const [fieldOptions, setFieldOptions] = useState([]);
  const [tab, setTab] = useState(1);
  const [usersShare, setUsersShare] = useState([]);
  const [rolesShare, setRolesShare] = useState([]);
  const [canEdit, setCanEdit] = useState(false);

	//WHERES
	const [conditionsFields, setConditionsFields] = useState([]);

	useEffect(() => {
		get_entity();
	}, []);

	const get_data_report = (entities) => { 
		setAppLoading(true);
		getReporteMutation(id, {
			onSuccess: (data) => {
				if(data){
					if(data.success){
						let reporte = data?.data;

            //USER VALIDATION
            if(data?.data?.usu_id === username){
              setCanEdit(true);
            }

            //PROCESS FIELDS
						let fields  = JSON.parse(data?.data?.repo_fields);
						dispatch(
							HEADER_DATA_UPDATE({nombreData: `Edición reporte personalizado ${reporte?.repo_id}`})
						)
						setOriginalList(structuredClone(entities));
						setConditionsFields(fields?.whereConditions)
						setReportName(data?.data?.repo_nombre)
						setReportDesc(data?.data?.repo_desc)
						let options = fields.report_fields.filter(item => item?.type === 'field');
						setFieldOptions(options)
						let entities_left_side = [...entities];
						let entities_rigth_side = [];
						for(let field of fields.report_fields){
							let entities_for = entities_left_side;
							if(field.type === "join" && field.alias){
								let exist_ent = entities_for.findIndex(item => item.alias === field.alias);
								if(exist_ent === -1){
									let principal_ent =  entities_for.find(item => item.name === field.field_target);
									let new_ent = {...principal_ent, alias: field.alias}
									entities_for.push(new_ent)
								}
							}
							let index_ent = field.alias && field.type === "field" ? 
                entities_for.findIndex(item => item?.name === field.field_origin && item.alias === field.alias) : 
                entities_for.findIndex(item => item?.name === field.field_origin);
							let index_ent_rigth = field.alias && field.type === "field" ? entities_rigth_side.findIndex(item => item?.name === field.field_origin && item.alias === field.alias) : entities_rigth_side.findIndex(item => item?.name === field.field_origin);
							if(index_ent_rigth === -1){
								let entidad = entities_left_side[index_ent];
								let name = field.middle_table ? field.middle_table : field.field;
								let col = entidad.columns.find(item => item.name === name);
								if(col){
									let new_ent_rigth = {
										name: entidad.name,
										columns: [col],
										relations: entidad.relations,
										alias: entidad.alias,
                    description: entidad.description
									}
									entities_rigth_side.push(new_ent_rigth)
								}
							}else{
								let entidad = entities_left_side[index_ent];
								let name = field.middle_table ? field.middle_table : field.field;
								let col = entidad.columns.find(item => item.name === name);
                if(!col){
                  col = entidad.columns.find(item => item.name === field.field_target);
                }
								entities_rigth_side[index_ent_rigth]?.columns.push(col)
							}

							if(index_ent !== -1){
								let name = field.middle_table ? field.middle_table : field.field;
								let index_col = entities_for[index_ent].columns.findIndex(item => item.name === name);
                if(index_col === -1){
                  index_col = entities_for[index_ent].columns.findIndex(item => item.name === field.field_target);
                }
								if(index_col !== -1){
									entities_for[index_ent].columns.splice(index_col, 1)
								}
							}
							
							entities_left_side = [...entities_for]
						}
						setRightList(entities_rigth_side)
						setLeftList(entities_left_side);
						setListaFiltrada(entities_left_side);

            //PROCESS SHARE
            let users = data?.data?.repo_userscompartidos?.split(',').map(user => user.trim()) || [];
            let roles = data?.data?.repo_rolescompartidos?.split(',').map(role => role.trim()) || [];
            setUsersShare(users);
            setRolesShare(roles);

            setAppLoading(false);
					}
				}
			},
			onError: (error) => {
				console.log(error);
				setAppLoading(false);
			}
		})
	}
  const get_entity = () => {
    setAppLoading(true)
    getEntityMutation({}, {
      onSuccess: (data) => {
      	get_data_report(data.data);
      },
      onError: (error) => {
        console.log(error);
        setAppLoading(false);
      }
    })
  }

  const handleSelect = (side, col, alias) => {

    let data = side === 'left' ? structuredClone(selectedToRight) : structuredClone(selectedToLeft);
    let data_left = null;
    let entity = alias !== undefined && alias !== null ?
      data.findIndex((item) => item?.alias === alias) :
      data.findIndex((item) => item?.name === col?.main_entity)
    
    if(side === 'left' && col?.relation_name){
      data_left = [...leftList];
			let original = [...originalList]
      let entity = data_left.findIndex((item) => item?.name === col?.main_entity);
      let item_exist = original[entity].columns.filter(item => item?.relation_name === col?.relation_name);
      if(item_exist.length > 1){
        let item_add = data_left.find(item => item?.name === col?.relation_name);
        let exist_alias = data_left.findIndex((ent) => ent.alias === col?.name);
        if(exist_alias === -1){
          data_left.push({
            name: item_add?.name,
            columns: item_add?.columns,
            relations: item_add?.relations,
            alias: col?.name,
            description: item_add?.description
          })
        }
        setLeftList([...data_left]);
      }
    }
    if(entity !== -1){
      const index = data[entity]?.columns?.findIndex(
        (item) => item?.name === col?.name
      );
      if (index !== -1) {
        // Si el objeto existe, lo eliminamos
        data[entity].columns.splice(index, 1)
      } else {
        // Si no existe, lo agregamos
        data[entity].columns.push(col)
      }
    }else{
      let entity = originalList.find(item => item?.name === col?.main_entity);
      let new_data = {
        name: col?.main_entity,
        columns: [col],
        relations: entity?.relations,
        alias,
        description: entity?.description
      }
      data.push(new_data)
    }


    side === 'left' ? setSelectedToRight([...data]) : setSelectedToLeft([...data]);

  }
  const handleSelectAllEntity = (side, entidad) => {
    let entities = side === 'left' ? structuredClone(selectedToRight) : structuredClone(selectedToLeft);
    let setEntities = side === 'left' ? setSelectedToRight : setSelectedToLeft;
    let exist = entities.findIndex(ent => ent.name === entidad.name && ent.alias === ent.alias);
    let columnas_data = [];
    if(exist === -1){
      entities.push(entidad);
      columnas_data = [...entidad.columns];
    }else{
      let columnas = [...entities[exist].columns, ...entidad.columns];
      let uniqueColumns = Array.from(
        new Map(columnas.map(obj => [obj.name, obj])).values()
      );
      entities[exist].columns = uniqueColumns;
      columnas_data = [...uniqueColumns];
    }

    if(side === 'left'){
      let data_left = [...leftList];
      columnas_data.map(col => {
        if(col.relation_name){
          let entity = data_left.findIndex((item) => item.name === col.main_entity);
          let item_exist = data_left[entity].columns.filter(item => item.relation_name === col.relation_name);
          if(item_exist.length > 1){
            let item_add = {...data_left.find(item => item.name === col.relation_name)};
            let exist_alias = data_left.findIndex((ent) => ent.alias === col.name);
            if(exist_alias === -1){
              data_left = [...data_left, {
                name: item_add.name,
                columns: item_add.columns,
                relations: item_add.relations,
                alias: col?.name
              }]
            }

            
          }
        }
      })
      setListaFiltrada([...data_left]);
      setLeftList([...data_left]);
      console.log(data_left)
    }
    setEntities(entities);
  }
	const moveItems = (side) => {
    let moveItems = side === 'left' ? structuredClone(selectedToRight) : structuredClone(selectedToLeft);
    let deleteItems = side === 'left' ? structuredClone(leftList) : structuredClone(rightList);
    let actualItems = side === 'left' ? structuredClone(rightList) : structuredClone(leftList);
    let setItems = side === 'left' ? setRightList : setLeftList;
    let setItemsDel = side === 'left' ? setLeftList : setRightList;
    //Agregar al lado a mover
    for(let entity of moveItems){
      let index_ent = entity?.alias !== undefined && entity?.alias !== null ?
      actualItems.findIndex((item) => item.alias === entity.alias) :
      actualItems.findIndex((item) => item.name === entity.name);
      let index_del = entity?.alias !== undefined && entity?.alias !== null ?
      deleteItems.findIndex((item) => item.alias === entity.alias) :
      deleteItems.findIndex((item) => item.name === entity.name);
      if(index_ent !== -1){
        entity.columns.map(col => {
          let index = actualItems[index_ent].columns.findIndex((item) => item.name === col.name);
          if(index === -1){
            actualItems[index_ent].columns.push(col)
          }
        })
      }else{
        actualItems.push(entity)
      }

      if(index_del !== -1){
        entity.columns.map(col => {
          let index = deleteItems[index_del].columns.findIndex((item) => item.name === col.name);
          if(index !== -1){
            deleteItems[index_del].columns.splice(index, 1);
            if(side === 'right'){
              let conditions = [...conditionsFields]
              conditions.map((or, index) => {

                let i_del = or.findIndex(and => and.field === col.name && and.alias === entity.alias);
								if(i_del !== -1){
									conditions[index].splice(i_del, 1);
								}
              })
              setConditionsFields([...conditions])
            }
          }
        })
      }

      if(deleteItems[index_del].columns.length === 0){
        deleteItems.splice(index_del, 1)
      }
    }

    // if(side === 'right'){
    //   let flag = true;
    //   while (flag) {
    //     flag = false;
    //     let verifyItems = [...deleteItems];
    //     deleteItems.map((entity, index) => {
    //       if(index !== 0){
    //         const relationsSet = new Set(entity.relations);
    //         let items_filter = verifyItems.filter(item => relationsSet.has(item.name));
    //         if(items_filter.length > 0){
    //           let exist = items_filter.some(item => 
    //             item?.columns?.some(col => 
    //               col.relation_name === entity.name || col.target_entity_inter === entity.name)
    //           )
    //           console.log(entity.name)
    //           console.log(exist)
    //           if(!exist){
    //             flag = true;
    //             let index_del = verifyItems.findIndex((item) => item.name === entity.name);
    //             let cols_to_add = verifyItems[index_del]?.columns;
    //             let index_add = actualItems.findIndex(item => item.name === entity.name);
    //             actualItems[index_add].columns.push(...cols_to_add);
    //             verifyItems.splice(index_del, 1);
    //           }
    //         }
    //       }
    //     })
    //     deleteItems = [...verifyItems]
    //   }

    // }
    if(side === 'left') setListaFiltrada([...deleteItems]);
    setItems([...actualItems]);
    setItemsDel([...deleteItems]);
    setSelectedToLeft([])
    setSelectedToRight([])
  }
  const createReportFields = () => {
    let data = [...rightList];

    let report_fields = [];
    for(let entity of data){
      let alias = entity.alias;
      for(let column of entity.columns){
        if(column.target_entity_inter){
          let exist = data.some(item => item.alias === column.name)
          let field = {
            type: 'join',
            field: column.origin_key,
            field_name: `Ref ${column.target_entity_inter}`,
            field_origin: column.main_entity,
            middle_table: column.relation_name,
            relation_type: column.relation_type,
            field_target: column.target_entity_inter,
            field_target_key: column.final_key,
            alias: exist ? column.name : null,
            inversa: column.inversa
          }
          report_fields.push(field)
        }else if(column.relation_name){
          let exist = data.some(item => item.alias === column.name)
          let field = {
            type: 'join',
            field: column.name,
            field_name: '',
            field_origin: column.main_entity,
            middle_table: null,
            relation_type: column.relation_type,
            field_target: column.relation_name,
            field_target_key: column.reference_db ? column.reference_db : column.name,
            alias: exist ? column.name : null,
            inversa: column.inversa,
            origin: column.origin_key
          }
          report_fields.push(field)
        }else{
          let field = {
            type: 'field',
            field: column.name,
            fiel_type: column.data_type,
            field_name: column.name,
            field_origin: column.main_entity,
            middle_table: null,
            relation_type: null,
            field_target: null,
            field_target_key: null,
            alias,
            inversa: column.inversa
          }
          report_fields.push(field)
        }
      }
    }
    let response = {
      initial_entity: data[0].name,
      report_fields,
      whereConditions: [...conditionsFields]
    }
    return response
  }
	const sendToSave = () => {
    let not_exist_null =  conditionsFields.every(subArray => 
      subArray.every(obj => 
          obj.type !== null &&
          obj.origin !== null &&
          obj.field !== null &&
          obj.operator !== null &&
          obj.value !== null &&
          obj.data_type !== null
      )
    );
    if(reportName === null || !not_exist_null){
      enqueueSnackbar( 'Complete los campos requeridos', {
        autoHideDuration: 2000,
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    }else{
      setAppLoading(true);
      let data_fields = createReportFields();
      let body = {
        repo_nombre: reportName,
        repo_desc: reportDesc,
        repo_fields: JSON.stringify(data_fields)
      }
      editarReporteMutation({id, body}, {
        onSuccess: (data) => {
          setAppLoading(false);
          enqueueSnackbar( data?.mensaje, {
            autoHideDuration: 2000,
            variant: data?.success ? "success" : "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
          navigate(`/reportes/personalizado`);
        },
        onError: (error) => {
          console.log(error)
        }
      })
    }
  }

	//FILTRO

	const search = (value) => {
		setFiltro(value)
		if(value === ""){
			setListaFiltrada([...leftList])
		}else{
			let data = leftList.map((item, index) => ({ ...item, indexOriginal: index }))
			.filter((item) => item.name.toLowerCase().includes(value.toLowerCase()));
			setListaFiltrada([...data])
		}
	}

	 //FUNCTIONS WHERE

	const createFieldsForWhere = () => {
    let data = [...rightList];

    let report_fields = [];
    for(let entity of data){
      let alias = entity.alias;
      for(let column of entity.columns){
        if(!column?.target_entity_inter && !column?.relation_name){
          let field = {
            type: 'field',
            field: column?.name,
            fiel_type: column?.data_type,
            field_name: column?.name,
            field_origin: column?.main_entity,
            middle_table: null,
            relation_type: null,
            field_target: null,
            field_target_key: null,
            alias
          }
          report_fields.push(field)
        }
      }
    }
    return report_fields
  }
  const items_filtro = createFieldsForWhere();

  const add_filtro = (grupo) => {
    let conditions = [...conditionsFields]
    let data = {
      type: "field",
      origin: null,
      field: null,
      operator: null,
      value:null,
      data_type: null,
      alias: null
    }
    conditions[grupo].push(data);
    setConditionsFields(conditions)
  }
  const delete_group = (grupo) => {
    let conditions = [...conditionsFields];
    conditions.splice(grupo, 1);
    setConditionsFields([...conditions])
  }
  const delete_filtro = (grupo, index) => {
    let conditions = [...conditionsFields];
    conditions[grupo].splice(index, 1);
    setConditionsFields([...conditions])
  }
  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();
    }
  };  
  const changeCondition = (grupo, index, value, type) => {
    let conditions = [...conditionsFields];
    switch (type) {
      case 1:
        if(value){
          conditions[grupo][index].origin = value?.field_origin;
          conditions[grupo][index].field = value?.field;
          conditions[grupo][index].data_type = value?.fiel_type;
          conditions[grupo][index].alias = value?.alias;
        }else{
          conditions[grupo][index].origin = null;
          conditions[grupo][index].field = null;
        }
        break;
      case 2:
        conditions[grupo][index].operator = value
        break;
      case 3:
        conditions[grupo][index].value = value
        break;
    
      default:
        break;
    }
    
    setConditionsFields(conditions)
  }
  //SELECT OPERATORS
  const operators = {
    numeric: ["=", "!=", ">", "<", ">=", "<="],
    string: ["=", "!=", "LIKE"],
    boolean: ["=", "!="],
    date: ["=", "!=", ">", "<", ">=", "<="],
  };
  const numericTypes = ["int", "double", "float", "decimal"];
  const stringTypes = ["varchar", "text", "char"];
  const dateTypes = ["date", "datetime", "timestamp"];
  const booleanTypes = ["bool", "boolean", "tinyint(1)"];

  const getOperatorsByType = (field_type) => {

    if (numericTypes.includes(field_type?.toLowerCase())) return operators.numeric;
    if (stringTypes.includes(field_type?.toLowerCase())) return operators.string;
    if (dateTypes.includes(field_type?.toLowerCase())) return operators.date;
    if (booleanTypes.includes(field_type?.toLowerCase())) return operators.boolean;

    // Default a solo igualdad y desigualdad si no reconoce el tipo
    return ["=", "!="];
  };

  //TAB
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const copy_reporte = (row) => {
    setAppLoading(true)
    copiarReporteMutation(id,{
      onSuccess: (data) => {
        setAppLoading(false);
        enqueueSnackbar(data?.mensaje, { 
          variant: data?.success ? 'success': 'error',
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          }, 
        });
      },
      onError: (error) => {
        console.log(error);
        enqueueSnackbar('Hubo un error al copiar el reporte', { 
          variant: 'error',
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          }, 
        });
        setAppLoading(false);
      }
    })
  }

	return(
		<>
			<Grid container spacing={0} sx={{mt:1}}>
				<Grid item xs={12} sm={12} md={6} lg={2} xl={2} sx={{p:1}} className="center_item">
					<FormControl fullWidth size="small" error={reportName === null}>
						<TextField
						id="report_name"
						name="report_name"
						size="small"
						fullWidth
						value={reportName}
						required
						sx={{
							mt: reportName === null ? 2 : 0
						}}
						onChange={
							(e) => {
								e.target.value === '' ? 
								setReportName(null) : 
								setReportName(e.target.value)
							}
						}
						/>
						<FormHelperText>{reportName === null ? 'Ingrese un nombre' : ''}</FormHelperText>
					</FormControl>
				</Grid>
				<Grid item xs={12} sm={12} md={6} lg={3} xl={3}  sx={{p:1}} className="center_item">
					<FormControl fullWidth size="small">
						<TextField
							id="report_desc"
							name="report_desc"
							size="small"
							fullWidth
							value={reportDesc}
							onChange={
								(e) => {
									e.target.value === '' ? 
									setReportDesc(null) : 
									setReportDesc(e.target.value)
								}
							}
							/>
						<FormHelperText>{''}</FormHelperText>
					</FormControl>
				</Grid>
				<Grid item xs={0} sm={0} md={0} lg={5} xl={5} sx={{p:1}} className="center_item">
				</Grid>
				<Grid item xs={12} sm={12} md={12} lg={2} xl={2} sx={{p:1}} className="center_item">
					<Button 
						variant="contained" 
						className="btn_system"
						onClick={sendToSave}
						>
							Guardar
					</Button>
				</Grid>
			</Grid>
			<Grid container spacing={2}  sx={{p:2}}>
				<Grid item xs={3} sx={{p:2, flexDirection: 'column'}} className="center_item">
					<TextField
						id="search_entity"
						label="Entidad"
						name="search_entity"
						size="small"
						fullWidth
						value={filtro}
						sx={{mb:2}}
						InputProps={{
							endAdornment: <Search/>
						}}
						onChange={(e) => search(e.target.value)}
						/>
					<SideList 
          key='left_list' 
          entities={listaFiltrada} 
          selectedTo={selectedToRight} 
          side='left' 
          handleSelect={handleSelect} 
          rightList={rightList}
          handleSelectAll={handleSelectAllEntity}
          />
				</Grid>
				<Grid item xs={2} sx={{p:1, alignItems: 'center', flexDirection: 'column', gap:2}} className="center_item">
					<Button variant="contained" className="btn_system" onClick={()=>moveItems('left')}> &gt; </Button>
					<Button variant="contained" className="btn_system" onClick={()=>moveItems('right')}> &lt; </Button>
				</Grid>
				<Grid item xs={3} sx={{p:1}} className="center_item">
					<SideList 
          key='right_list' 
          entities={rightList} 
          selectedTo={selectedToLeft} 
          side='right' 
          handleSelect={handleSelect} 
          rightList={rightList}
          handleSelectAll={handleSelectAllEntity}
          />
				</Grid>
				<Grid item xs={4} sx={{flexDirection:'column', justifyContent:'flex-start'}} className="center_item">
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%', textAlign: 'center' }}>
              <TabList onChange={handleChange} aria-label="tabs filtros/permisos reporte">
                <Tab label='Filtros' value={1} />
                {canEdit && <Tab label='Usuarios' value={2} />}
                {canEdit && <Tab label='Acciones' value={3} />}
              </TabList>
            </Box>
            <TabPanel value={1} sx={{width: '100%', p:0}}>
              <Button 
                variant="outlined" 
                className="btn_system"
                fullWidth
                onClick={()=>setConditionsFields([...conditionsFields, []])}
                sx={{mt:2}}
                >
                + Nuevo grupo
              </Button>
              {conditionsFields?.map((group, index_group) => (
                  <div key={`div_group_${index_group}`} style={{width: '100%', border:'1px solid #575E3B', borderRadius: 12, display:'flex', flexDirection: 'column', padding:5, marginTop:15}}>
                    <Grid container spacing={0} sx={{display: 'flex', justifyContent:'space-between'}} >
                      <Grid item xs={4} sx={{p:1}} className="center_item">
                        <Button 
                        variant="contained" 
                        className="btn_system"
                        fullWidth
                        onClick={()=>add_filtro(index_group)}
                        >
                        + Nuevo filtro
                        </Button>
                      </Grid>
                      <Grid item xs={3} sx={{p:1, justifyContent: 'flex-end'}} className="center_item">
                        <IconButton 
                          aria-label="delete"
                          onClick={()=> delete_group(index_group)}
                          >
                          <Cancel />
                        </IconButton>
                      </Grid>
                    </Grid>
                    {group?.map((cond, index_cond) => (
                      <Grid container spacing={0} >
                        <Grid item xs={5} sx={{p:1}} className="center_item">
                          <FormControl size="small" fullWidth>
                            <Autocomplete
                            fullWidth
                            id={`item_column_${index_cond}_g${index_group}`}
                            getOptionLabel={(opcion) => opcion?.alias ? `${opcion.field}(${opcion.alias})` : opcion.field}
                            filterSelectedOptions
                            options={items_filtro}
                            onKeyDown={handleKeyUp}
                            value={cond !== null ? items_filtro.find(item => item?.field === cond?.field) : null}
                            onChange={(e, newValue)=>changeCondition(index_group, index_cond, newValue, 1)}
                            renderOption={(props, option)=> (
                                <Box {...props} key={`${index_group}_${index_cond}_${option?.field}`}>{`${option?.field} ${option?.alias ? `(${option.alias})` : ''}`}</Box>
                            )}
                            renderInput={(params) => 
                                <TextField {...params} label="Campo" size="small" fullWidth  required/>
                            }
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={2} sx={{p:1}} className="center_item">
                          <Select
                            key={index_cond}
                            labelId={`operator-select-${index_group}-${index_cond}`}
                            id={`operator-select-${index_group}-${index_cond}`}
                            name={`operator-select-${index_group}-${index_cond}`}
                            value={cond?.operator}
                            onChange={(e) => changeCondition(index_group, index_cond, e.target.value, 2)}
                            displayEmpty
                          >
                            {getOperatorsByType(cond?.data_type).map((op) => (
                                <MenuItem key={op} value={op}>{op}</MenuItem>
                            ))}
                          </Select>
                        </Grid>
                        <Grid item xs={4} sx={{p:1}} className="center_item">
                          {
                            booleanTypes.some(item => item === cond?.data_type) ? (
                              <Select
                              key={index_cond}
                              labelId={`item_value_${index_cond}_g${index_group}`}
                              id={`item_value_${index_cond}_g${index_group}`}
                              name={`item_value_${index_cond}_g${index_group}`}
                              value={cond?.value}
                              onChange={(e) => changeCondition(index_group, index_cond, e.target.value, 3)}
                              displayEmpty
                              fullWidth
                            >
                              <MenuItem key={`true-${index_group}-${index_cond}`} value={true}>True</MenuItem>
                              <MenuItem key={`false-${index_group}-${index_cond}`} value={false}>False</MenuItem>
                              </Select>
                            ) : (
                              <TextField
                                id={`item_value_${index_cond}_g${index_group}`}
                                type={
                                  dateTypes.some(item => item === cond.data_type) ? "date": 
                                  numericTypes.some(item => item === cond.data_type) ? "number" :
                                  "text"
                                }
                                fullWidth
                                size="small"
                                value={cond?.value}
                                name={`item_value_${index_cond}_g${index_group}`}
                                hiddenLabel
                                placeholder="Valor referencia"
                                onChange={(e) => changeCondition(index_group, index_cond, e.target.value, 3)}
                                className="input-date"
                              />
                            )
                          }
                          
                        </Grid>
                        <Grid item xs={1} sx={{p:1}} className="center_item">
                          <IconButton 
                          aria-label="delete"
                          onClick={()=> delete_filtro(index_group, index_cond)}
                          >
                            <Delete />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ))}
                  </div>
              ))}
            </TabPanel>
            {canEdit && (
              <TabPanel value={2} sx={{width: '100%', p:0}}>
                <UserActions
                key='user_actions'
                id_reporte={id}
                users_share={usersShare}
                set_user_share={setUsersShare}
                set_roles_share={setRolesShare}
                roles_share={rolesShare}
                />
              </TabPanel>
            )}
            {canEdit && (
              <TabPanel value={3} sx={{width: '100%', p:0}}>
                <Button 
                  variant="contained" 
                  className="btn_system"
                  fullWidth
                  onClick={copy_reporte}
                  sx={{mt:2}}
                  >
                  Copiar Reporte
                </Button>
              </TabPanel>
            )}
          </TabContext>
				</Grid>
			</Grid>
		</>
	)
}